// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"597":"c4cd344a","744":"08d28ec0","898":"8646b594","920":"fe875057","924":"4bc115fc"}[chunkId] + ".js";
};